import type { CMSConfig } from '#types/config/components/cms'

export default {
  brandClasses: {
    backdropContainer: 'py-6 space-y-2 lg:py-10',
    contentContainer: 'z-1 flex items-center px-4 lg:(pointer-events-none px-6 grid-area-stack)'
  }
} satisfies CMSConfig['bannerThin']
